import { Link } from 'react-router-dom'

export const Footer: React.FC = () => {
  return (
    <footer className="py-12 md:py-[88px] pb-12 md:pb-[48px] bg-white border-t border-stone">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="foot-row">
          <div>
            <img 
              src="/logos/Jobloads+Logotype+Bright-08.png" 
              alt="Jobloads" 
              className="h-7 md:h-[28px] w-auto logo-img" 
            />
            <p className="mt-4 text-[15px] text-fg-3 max-w-[280px] leading-relaxed">
              Closing the transport gap for the frontline workforce.
            </p>
          </div>
          <div>
            <div className="foot-h text-xs font-semibold text-fg-4 mb-[18px]">Product</div>
            <Link className="foot-link" to="/#crewloads">Crewloads</Link>
            <Link className="foot-link" to="/#stay-updated">Stay updated</Link>
          </div>
          <div>
            <div className="foot-h text-xs font-semibold text-fg-4 mb-[18px]">Legal</div>
            <Link className="foot-link" to="/terms">Terms of use</Link>
            <Link className="foot-link" to="/privacy">Privacy policy</Link>
          </div>
          <div>
            <div className="foot-h text-xs font-semibold text-fg-4 mb-[18px]">Connect</div>
            <Link className="foot-link" to="/contact">Contact us</Link>
            <a className="foot-link" href="mailto:hello@jobloads.com">hello@jobloads.com</a>
          </div>
        </div>
        <div className="foot-base flex justify-between items-center pt-7 border-t border-stone text-xs text-fg-4 font-medium">
          <span>© 2026 Jobloads Limited</span>
        </div>
      </div>
    </footer>
  )
}

